import React from 'react';
import styled from 'styled-components';
import { formatMoney } from '~/helpers/currency';
import { ReleasingIcon } from '@kvdbil/components';
import { AlignIcon } from '~/App/shared/components/Layout/AlignIcon';
import { useTranslation } from '~/Locale';

const BiddingMessageReleasing = styled.div`
  color: ${({ theme }) => theme.colors.grayscaleToned.dark3};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 7px;
`;

const BiddingMessageReleasingLabel = styled.div`
  text-transform: uppercase;
  font-weight: ${({ theme }) => theme.typography.fontBaseBoldWeight};
  font-size: 0.75em;
`;

const BiddingMessageReleasingValue = styled.div`
  font-size: 1em;
  margin-left: 15px;
`;

export interface ReleasingCostProps {
  cost: number;
}
export const ReleasingCost = ({ cost }: ReleasingCostProps) => {
  const { t } = useTranslation();
  return (
    <BiddingMessageReleasing>
      <BiddingMessageReleasingLabel>
        <AlignIcon right={0.5}>
          <ReleasingIcon />
          {t('Releasing cost')}
        </AlignIcon>
      </BiddingMessageReleasingLabel>
      <BiddingMessageReleasingValue>
        {formatMoney({
          value: cost,
          currency: t('SEK/month')
        })}
      </BiddingMessageReleasingValue>
    </BiddingMessageReleasing>
  );
};

export default ReleasingCost;
